export default __webpack_public_path__ + "static/media/StefanPetrov.9e69e280.png";